function SkeletonBlock({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-xl bg-surface-subtle ${className}`} />;
}

export function DashboardSkeleton() {
  return (
    <div aria-busy="true" aria-label="Carregando dashboard" className="space-y-s5">
      <div className="grid grid-cols-1 gap-s3 sm:grid-cols-2 xl:grid-cols-5">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="card-premium p-s5">
            <div className="mb-s3 flex items-center justify-between">
              <SkeletonBlock className="h-3 w-20" />
              <SkeletonBlock className="h-4 w-4 rounded-md" />
            </div>
            <SkeletonBlock className="mb-s2 h-7 w-16" />
            <SkeletonBlock className="h-3 w-24" />
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-s5 lg:grid-cols-2">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="card-premium overflow-hidden">
            <div className="border-b border-subtle px-s5 py-s3">
              <SkeletonBlock className="h-3 w-40" />
            </div>
            <div className="p-s5 md:p-s6">
              <SkeletonBlock className="mb-s4 h-3 w-56" />
              <SkeletonBlock className="h-48 w-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
